/* Scoped token re-point only — no layout, no colors of its own.

   The signed-out screens paint their accents from the theme's ink rather than
   its accent colour, and each pair inverts together so both stay correct in
   light mode.

   Astryx's Field re-declares the whole token set on its own container, so an
   override inherited from an ancestor loses to it: the re-point has to land on
   the component's own root. Focus borders and outlines draw from
   --color-accent. */

.field {
  --color-accent: var(--color-text-primary);
}
